// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__eTo6R {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 25px 80px;

  @media (max-width: 1024px) {
    padding: 20px;
  }
}

.style_specific__DtGmQ {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: 20px;
  gap: 40px;

  @media (max-width: 770px) {
    flex-direction: column;
  }
}

.style_specific__DtGmQ > div {
  width: 100%;
}

.style_fields__oPbKE {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.style_fields_inputs__wh8G9 {
  border: 1px solid var(--table-border);
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  min-height: 400px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  background-color: var(--table-row-white);
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 1024px) {
    width: 100%;
  }

  @media (min-width: 1025px) {
    width: 100%;
  }
}

.style_account_info__yCSaq {
  display: flex;
  gap: 4px;
  align-items: center;
}

.style_fields_maintenance__aam8O {
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: -moz-fit-content;
  height: fit-content;

  @media (max-width: 1024px) {
    width: 100%;
  }

  @media (min-width: 1025px) {
    width: 100%;
    min-height: 500px;
  }
}
.style_upcoming__gRtKY {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.style_maintenance__e9zB7 {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  padding: 20px;
  gap: 10px;
  border: 1px solid var(--table-border);
  border-radius: 4px;
  width: 100%;
}

.style_task__6jJ\\+R {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 15px;
  border-radius: 4px;
  border: 1px dashed var(--text-heading);
  background: rgba(151, 71, 255, 0.04);
}

.style_double_fields__U5x-m {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.style_sub_header__BM5bm {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/pages/MachineProfile/style.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;;EAElB;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,SAAS;;EAET;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wBAAmB;EAAnB,mBAAmB;;EAEnB;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC","sourcesContent":[".container {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 25px 80px;\n\n  @media (max-width: 1024px) {\n    padding: 20px;\n  }\n}\n\n.specific {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding-top: 20px;\n  gap: 40px;\n\n  @media (max-width: 770px) {\n    flex-direction: column;\n  }\n}\n\n.specific > div {\n  width: 100%;\n}\n\n.fields {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n}\n\n.fields_inputs {\n  border: 1px solid var(--table-border);\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  min-height: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  background-color: var(--table-row-white);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n  @media (max-width: 1024px) {\n    width: 100%;\n  }\n\n  @media (min-width: 1025px) {\n    width: 100%;\n  }\n}\n\n.account_info {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.fields_maintenance {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  height: fit-content;\n\n  @media (max-width: 1024px) {\n    width: 100%;\n  }\n\n  @media (min-width: 1025px) {\n    width: 100%;\n    min-height: 500px;\n  }\n}\n.upcoming {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n}\n\n.maintenance {\n  display: flex;\n  box-sizing: border-box;\n  flex-direction: column;\n  padding: 20px;\n  gap: 10px;\n  border: 1px solid var(--table-border);\n  border-radius: 4px;\n  width: 100%;\n}\n\n.task {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 15px;\n  border-radius: 4px;\n  border: 1px dashed var(--text-heading);\n  background: rgba(151, 71, 255, 0.04);\n}\n\n.double_fields {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n\n.sub_header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__eTo6R`,
	"specific": `style_specific__DtGmQ`,
	"fields": `style_fields__oPbKE`,
	"fields_inputs": `style_fields_inputs__wh8G9`,
	"account_info": `style_account_info__yCSaq`,
	"fields_maintenance": `style_fields_maintenance__aam8O`,
	"upcoming": `style_upcoming__gRtKY`,
	"maintenance": `style_maintenance__e9zB7`,
	"task": `style_task__6jJ+R`,
	"double_fields": `style_double_fields__U5x-m`,
	"sub_header": `style_sub_header__BM5bm`
};
export default ___CSS_LOADER_EXPORT___;
